import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IntentId, EnvironmentType } from '@feedyou-ai/feedbot-schema'

import { OpenedIntentState } from './types'

export const initialState: OpenedIntentState = {
  searchValue: '',
  isIntentExpandedForId: {},
  sourceEnvironmentForTraining: 'prod'
}

export const { reducer, actions } = createSlice({
  name: 'nlpEditor',
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload
    },
    setIsIntentExpandedForId: (
      state,
      action: PayloadAction<{ intentId: IntentId; isExpanded: boolean }>
    ) => {
      const { intentId, isExpanded } = action.payload

      state.isIntentExpandedForId[intentId] = isExpanded
    },
    setSourceEnvironmentForTraining: (
      state,
      action: PayloadAction<{ sourceEnvironmentForTraining: EnvironmentType }>
    ) => {
      state.sourceEnvironmentForTraining = action.payload.sourceEnvironmentForTraining
    }
  }
})
